import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { CampaignsServiceProvider } from '../../api/campaigns'

const CampaignsService = CampaignsServiceProvider()
const name = 'getCampaignStatus'

export default ({ campaignId }) => {
  return asyncAction(
    name,
    CampaignsService.getCampaignStatus,
    { campaignId }
  )
}

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/campaign/getCampaignStatus.js